import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
/**
 * Progress Tracker Component
 * Displays progress of steps displaying dots that show active, non-active, and disabled states.
 *
 * Currently only used in onboarding
 *
 * @param TrackerSteps (TrackerStep[]) state of the tracker stepssteps/changes for those steps
 *
 * @example
 *
 * ```
 * <dgx-tracker [TrackerSteps]="updateTrackerStates | async"></dgx-tracker>
 * ```
 */

export interface TrackerStep {
  stepDisplayName: string;
  stepName: string;
  stepUrl: string;
  isActive: boolean;
  isDisabled: boolean;
}
@Component({
  selector: 'dgx-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackerComponent {
  @Input() public trackerSteps: Observable<TrackerStep[]>;
  @Output()
  public trackerEvent: EventEmitter<TrackerStep> = new EventEmitter<TrackerStep>();  

  public onTrackerClicked(step: TrackerStep){
    this.trackerEvent.emit(step)
  }
}
